export default __webpack_public_path__ + "static/media/responsive_welcome_to_lovrican.78698d10.webp";